import { render, staticRenderFns } from "./CakeIcon.vue?vue&type=template&id=1050c666&"
import script from "./CakeIcon.vue?vue&type=script&lang=js&"
export * from "./CakeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports